// extracted by mini-css-extract-plugin
export default {"container":"FieldPayerIsCustomer_container__vmemw"};